var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.13 12.25c-.63 0-1.13-.5-1.13-1.13v-6A1.13 1.13 0 0 1 3.13 4h9.75A1.13 1.13 0 0 1 14 5.13v6c0 .62-.5 1.12-1.13 1.12H3.13Zm-.38-1.13c0 .21.17.38.38.38h9.75c.2 0 .37-.17.37-.38v-5.9l-2.8 1.94L12 8.6a.38.38 0 0 1-.5.55L9.8 7.59l-.9.63a1.57 1.57 0 0 1-1.8 0l-.9-.63-1.7 1.56a.38.38 0 0 1-.53-.02A.38.38 0 0 1 4 8.6l1.57-1.44-2.81-1.94v5.9ZM7.53 7.6a.83.83 0 0 0 .94 0l4.14-2.85H3.39L7.53 7.6Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.49dc0a66baac700e66a56b0f0376ad2c.svg";
export { ForwardRef as ReactComponent };